//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from "vue";
import LazyHydrate from "vue-lazy-hydration";

export default Vue.extend({
  name: "ExploreCharacters",
  components: {
    LazyHydrate,
    MoominExploreCharacters: () => import("~/themes/fiskarsMoominDefault/components/components/organisms/MoominExploreCharacters/MoominExploreCharacters.vue") 
  },
  methods: {
    getHeroBackground(item) {
      return item?.background?.selectionValues[0]?.key ? item?.background?.selectionValues[0]?.key : 'var(--c-secondary-sand)';
    }
  },
  props: {
    background: {
        type: Object,
    },
    title: {
        type: String,
        defautl: ''
    },
    description: {
        type: String,
        default: ''
    },
    subtitle: {
        type: String,
        default: ''
    },
    showTooltip: {
      type: Boolean,
      default: false
    },
    navigationButtonText: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => [],
      validator: (items) => {
        if(!items.length) return true;

        const keysNeeded = ['characterName', 'image'];

        return items.every(char => {
          return keysNeeded.every(key => {
            return typeof char[key] != 'undefined';
          })
        })
      }
    },
  },
});
